import type { CustomFile } from '../types';

// ----------------------------------------------------------------------------

function toCustomFile(file: File, relativePath?: string): CustomFile {
    const customFile: CustomFile = file;

    if (relativePath != null) {
        customFile.relativePath = relativePath;
    } else if (file.webkitRelativePath) {
        customFile.relativePath = file.webkitRelativePath;
    }

    return customFile;
}

// ----------------------------------------------------------------------------

export default toCustomFile;
